import { testDb } from './test-dataset';

// dev and test dataset same at the moment
export const devDb = testDb;
